/* UPDATE SOFTSKILLS USER */
export const UPDATE_SOFTSKILLS_USER = "UPDATE_SOFTSKILLS_USER"
export const UPDATE_SOFTSKILLS_USER_SUCCESS = "UPDATE_SOFTSKILLS_USER_SUCCESS"
export const UPDATE_SOFTSKILLS_USER_CLEAN = "UPDATE_SOFTSKILLS_USER_CLEAN"
export const UPDATE_SOFTSKILLS_USER_ERROR = "UPDATE_SOFTSKILLS_USER_ERROR"
